import React, {useContext} from "react";
import {FormattedMessage} from "react-intl";

import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

import LookAiPopupContext from "./LookAiPopupContext";
import {IS_QKB_UI} from "../../../../config";
import {getCurrentLayout} from "../../../appLayout";
import {hideGroupObject} from "../../aiFunctions";


const LookAIPopupFeatureGroups = (props) => {

  const {setLookAiExportData} = props;

  const {lookAiPopupContext, lookAiPopupDispatch} = useContext(LookAiPopupContext);
  const {groupObjects} = lookAiPopupContext;

  const onCheckboxClick = (gr) => {
    const newGroupObjects = groupObjects.map(groupObject => {
      if (groupObject.partId === gr.partId) {
        groupObject.enabled = !groupObject.enabled;
      }
      return groupObject
    })
    lookAiPopupDispatch({
      groupObjects: newGroupObjects,
    });
    setLookAiExportData(newGroupObjects); // keep groupObjects only, we will update export object on save
    const layout = getCurrentLayout();
    layout.updateLocalStorage();
  }

  return (
    <div className="flex flex--column look-ai__content-groups" id="look-ai__panel-feature-groups">
      <div className="mt-0 mb-1 flex flex--column flex--top w-full">
        <p className={"m-0 bold" + (IS_QKB_UI ? " color-primary" : "")}>
          <FormattedMessage id="look.ai.panel.generateItems"/>
        </p>
        <p className="m-0 font--12 leading-1 look-ai__panel-text">
          <FormattedMessage id="look.ai.panel.generateItemsText"/>
        </p>
      </div>
      <ul className="m-0 p-0 w-full">
        {groupObjects ? groupObjects.map(groupObject => {
          if (hideGroupObject(groupObject)) {
            return null
          }
          return (
            <li key={groupObject.featureGroup.partId} className="mb-025">
              <FormControlLabel
                style={{color: "#66778D"}}
                // label={getFeatureGroupName(groupObject.featureGroup, intl, fabricatorData)}
                label={groupObject.featureGroup.dbName || groupObject.featureGroup.partName}
                className="m-0"
                control={
                  <Switch
                    checked={groupObjects.some(gr => gr.partId === groupObject.partId && gr.enabled)}
                    className="gm-ios-checkbox"
                    disableRipple
                    onChange={() => onCheckboxClick(groupObject)}
                    color="primary"
                  />
                }
              />
            </li>
          )
        }) : null}
      </ul>
    </div>
  )
};

export default LookAIPopupFeatureGroups
